import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavItem } from '../../../models/navItem';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../../../services/auth.service';
import { CandidatService } from '../../../services/candidat.service';
import { NotificationRealtimeService } from '../../../services/notification-realtime.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-candidat-header',
  templateUrl: './candidat-header.component.html',
  styleUrl: './candidat-header.component.scss',
})
export class CandidatHeaderComponent implements OnInit, OnDestroy {
  condidat: any;
  notifNotReaded: number = 0;
  candidatId: number | null;
  private realtimeSub?: Subscription;
  navList: NavItem[] = [
    { id: 1, label: 'accueil', icon: 'house', route: 'accueil' },
    {
      id: 2,
      label: 'Tableaux de bord de mes missions',
      icon: 'valid-calendar',
      route: 'planning',
    },
    {
      id: 3,
      label: 'Nouvelle recherche de missions',
      icon: 'search',
      route: 'recherche',
    },
  ];

  routerSelected: number | undefined = 1;
  notification: any;
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private authService: AuthService,
    private condidatApi: CandidatService,
    private realtime: NotificationRealtimeService
  ) {
    const url = router.url;
    this.routerSelected = this.navList.find((a) => url.includes(a.route))?.id;
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.routerSelected = this.navList.find((a) =>
          val.url.includes(a.route)
        )?.id;
      }
    });
    this.candidatId = this.authService.id;
    this.condidat = localStorage.getItem('candidat')
      ? JSON.parse(localStorage.getItem('candidat') || '{}')
      : null;
  }
  ngOnInit() {
    this.notifications();
    this.condidat = localStorage.getItem('candidat')
      ? JSON.parse(localStorage.getItem('candidat') || '{}')
      : null;
    // Live updates: prepend new notifications and bump the unread badge without a refresh.
    this.realtime.connect();
    this.realtimeSub = this.realtime.notifications$.subscribe((notif) => {
      this.notification = [notif, ...(this.notification || [])];
      this.notifNotReaded = (this.notifNotReaded || 0) + 1;
    });
  }

  ngOnDestroy(): void {
    this.realtimeSub?.unsubscribe();
    this.realtime.disconnect();
  }

  // fetchCondidat() {
  //   this.condidatApi.getCondidatById(this.candidatId).subscribe({
  //     next: (res) => {
  //       this.condidat = res;
  //     },
  //     error: (err) => console.log(err),
  //   });
  // }
  notifications() {
    this.authService.notif().subscribe({
      next: (res: any) => {
        this.notification = res;
        this.notifNotReaded = res?.filter((el: any) => !el.read).length;
      },
      error: (err) => console.log(err),
    });
  }
  notifClicked(notif: any) {
    this.authService.readNotif(notif.id, { ...notif, read: true }).subscribe({
      next: (res) => {
        this.notifications();
        // this.router.navigateByUrl(`/missinDetails/${notif.mission_id}`);
        window.location.replace(`/missinDetails/${notif.mission_id}`);
      },
    });
    // this.notification = this.notification.map((el: any) => {
    //   if (el.mission_id == id) {
    //     el.read = true;
    //   }
    //   return el;
    // });
    // localStorage.setItem('notif', JSON.stringify(this.notification));
  }
  handleClickNav(navItem: NavItem) {
    this.routerSelected = navItem.id;
  }
  disconnect() {
    localStorage.clear();
    this.authService.disconnect();
  }
}
